<div *ngIf="isLoggedIn$ | async" class="topbar clearfix">
    <div class="topbar-left">
      <img class="topbar-logo" src="assets/images/logo.svg">
    </div>
    <div class="topbar-right">
      <a href="#" (click)="handleToggleMenu($event)" id="menu-button"><i class="fa fa-angle-right"></i></a>
      <div class="log-out">
        <button pButton (click)="handleLogOut($event)" class="log-out-icon" type="button" i18n-label label="Log out" icon="pi pi-sign-out"></button>
      </div>
      <div *ngIf="currentUser" class="user-info">
        <div class="user-name">{{currentUser.firstName}} {{currentUser.lastName}}</div>
        <div class="user-role">{{currentUser.role|userRole}}</div>
      </div>
      <app-global-status></app-global-status>
    </div>
 </div>
